export interface MovieItem {
  id: string;
  title: string;
  poster: string;
  year: string;
  region: string;
  genre: string;
  rating: string;
  desc: string;
}

export interface TvItem {
  id: string;
  title: string;
  tab: string;
  poster: string;
  year: string;
  region: string;
  genre: string;
  rating: string;
  episodes: string;
  desc: string;
}

export const latestMovies: MovieItem[] = [
  {
    id: "m1",
    title: "雾都迷踪",
    poster:
      "https://readdy.ai/api/search-image?query=rain%20soaked%20cobblestone%20alley%20at%20dusk%20with%20a%20solitary%20figure%20in%20a%20long%20coat%2C%20warm%20amber%20streetlight%20glow%2C%20moody%20crime%20noir%20film%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p01&orientation=portrait",
    year: "2024",
    region: "中国大陆",
    genre: "悬疑",
    rating: "8.6",
    desc: "一桩跨越十年的旧案在浓雾之城重新浮出水面，退休警探与年轻记者联手追查，层层反转直指被掩埋的真相。",
  },
  {
    id: "m2",
    title: "山海拾光",
    poster:
      "https://readdy.ai/api/search-image?query=epic%20fantasy%20landscape%20with%20floating%20mountains%20and%20a%20glowing%20ancient%20tree%2C%20warm%20golden%20light%2C%20adventurous%20painterly%20film%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p02&orientation=portrait",
    year: "2024",
    region: "中国大陆",
    genre: "奇幻",
    rating: "8.1",
    desc: "少年为寻找失落的古图踏上跨越山海的旅程，途中结识的伙伴各自怀揣秘密，一段关于成长与守护的东方奇幻。",
  },
  {
    id: "m3",
    title: "长夜将尽",
    poster:
      "https://readdy.ai/api/search-image?query=lonely%20rural%20train%20station%20at%20dawn%20with%20a%20single%20traveler%20and%20warm%20sunrise%20light%2C%20nostalgic%20melancholy%20drama%20film%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p03&orientation=portrait",
    year: "2023",
    region: "中国大陆",
    genre: "剧情",
    rating: "8.8",
    desc: "小镇青年在离乡与留守之间反复拉扯，一次意外的归途让他重新理解父亲沉默多年的选择。",
  },
  {
    id: "m4",
    title: "霓虹旧梦",
    poster:
      "https://readdy.ai/api/search-image?query=retro%201990s%20night%20market%20alley%20with%20colorful%20neon%20signs%20and%20vintage%20motorcycles%2C%20warm%20nostalgic%20glow%2C%20cinematic%20film%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p04&orientation=portrait",
    year: "2023",
    region: "中国香港",
    genre: "犯罪",
    rating: "8.3",
    desc: "九十年代的旧城区里，两个小人物在一场注定失败的计划中相遇，霓虹灯下的义气与背叛交织成一首时代挽歌。",
  },
  {
    id: "m5",
    title: "追风少年",
    poster:
      "https://readdy.ai/api/search-image?query=young%20athlete%20running%20on%20a%20track%20at%20golden%20hour%2C%20dust%20and%20warm%20sunlight%2C%20inspirational%20dynamic%20sports%20film%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p05&orientation=portrait",
    year: "2024",
    region: "中国大陆",
    genre: "运动",
    rating: "7.9",
    desc: "来自山区的短跑少年在教练的打磨下冲击全国赛场，天赋与汗水之外，他还要跑赢自己的心魔。",
  },
  {
    id: "m6",
    title: "寂静回声",
    poster:
      "https://readdy.ai/api/search-image?query=abandoned%20hospital%20corridor%20with%20a%20single%20flashlight%20beam%2C%20dramatic%20shadows%2C%20tense%20suspense%20film%20poster%20art%2C%20warm%20desaturated%20tones%2C%20no%20text&width=400&height=600&seq=bajie-p06&orientation=portrait",
    year: "2024",
    region: "韩国",
    genre: "惊悚",
    rating: "8.0",
    desc: "一群年轻人进入废弃医院的直播探险，耳机里传来的回声却预言了他们各自的结局。",
  },
  {
    id: "m7",
    title: "味觉记忆",
    poster:
      "https://readdy.ai/api/search-image?query=rustic%20kitchen%20with%20steaming%20dishes%20and%20warm%20hanging%20lanterns%2C%20cozy%20appetizing%20mood%2C%20soft%20golden%20light%2C%20food%20drama%20film%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p07&orientation=portrait",
    year: "2023",
    region: "中国大陆",
    genre: "美食",
    rating: "8.4",
    desc: "一间濒临关门的老饭馆，一位守着祖传菜谱的厨师，用一道道家常菜串起食客们的悲欢离合。",
  },
  {
    id: "m8",
    title: "北境之歌",
    poster:
      "https://readdy.ai/api/search-image?query=snowy%20northern%20wilderness%20with%20a%20lone%20rider%20and%20a%20distant%20warm%20campfire%2C%20cold%20desolate%20yet%20hopeful%20mood%2C%20epic%20film%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p08&orientation=portrait",
    year: "2024",
    region: "挪威",
    genre: "冒险",
    rating: "8.2",
    desc: "极夜降临的北境，一位牧人为了族人的存续踏上千里雪原，在荒芜中寻找最后一片可以栖息的土地。",
  },
  {
    id: "m9",
    title: "云端之上",
    poster:
      "https://readdy.ai/api/search-image?query=couple%20silhouette%20on%20a%20rooftop%20above%20a%20city%20at%20sunset%2C%20warm%20orange%20sky%2C%20romantic%20cinematic%20film%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p09&orientation=portrait",
    year: "2023",
    region: "中国台湾",
    genre: "爱情",
    rating: "7.8",
    desc: "两个在深夜电台相识的陌生人，用一整年的凌晨通话靠近彼此，却始终不敢说出那句见面。",
  },
];

export const tvShows: TvItem[] = [
  {
    id: "t1",
    title: "家国长卷",
    tab: "国产剧",
    poster:
      "https://readdy.ai/api/search-image?query=grand%20traditional%20chinese%20courtyard%20mansion%20in%20autumn%20with%20red%20lanterns%2C%20warm%20nostalgic%20period%20drama%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p10&orientation=portrait",
    year: "2024",
    region: "中国大陆",
    genre: "年代",
    rating: "9.0",
    episodes: "全 42 集",
    desc: "一个家族三代人的命运沉浮，映照出半个世纪的时代变迁，写尽普通人在洪流中的坚守。",
  },
  {
    id: "t2",
    title: "都市浮生",
    tab: "国产剧",
    poster:
      "https://readdy.ai/api/search-image?query=modern%20high%20rise%20city%20skyline%20at%20dusk%20with%20warm%20office%20lights%2C%20contemplative%20urban%20drama%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p11&orientation=portrait",
    year: "2024",
    region: "中国大陆",
    genre: "都市",
    rating: "8.5",
    episodes: "全 36 集",
    desc: "五位在上海打拼的年轻人，在加班、租房与理想之间反复碰撞，寻找属于自己的节奏。",
  },
  {
    id: "t3",
    title: "烟火人间",
    tab: "国产剧",
    poster:
      "https://readdy.ai/api/search-image?query=cozy%20chinese%20family%20dinner%20table%20with%20steaming%20dishes%20and%20warm%20lamps%2C%20heartwarming%20realistic%20family%20drama%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p12&orientation=portrait",
    year: "2023",
    region: "中国大陆",
    genre: "家庭",
    rating: "8.7",
    episodes: "全 40 集",
    desc: "老巷子里的街坊四邻，用一顿顿晚饭串起鸡毛蒜皮里的温情，讲的是人间最实在的日子。",
  },
  {
    id: "t4",
    title: "长安谜案",
    tab: "国产剧",
    poster:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20palace%20corridor%20with%20paper%20lanterns%20and%20a%20figure%20in%20hanfu%2C%20warm%20mysterious%20period%20mystery%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p13&orientation=portrait",
    year: "2024",
    region: "中国大陆",
    genre: "古装悬疑",
    rating: "8.9",
    episodes: "全 32 集",
    desc: "盛唐长安接连发生离奇命案，落魄书生与大理寺少卿携手断案，牵出一桩牵扯朝堂的旧秘。",
  },
  {
    id: "t5",
    title: "暗流",
    tab: "美剧",
    poster:
      "https://readdy.ai/api/search-image?query=american%20suburban%20street%20at%20night%20with%20a%20single%20lit%20house%20window%2C%20ominous%20suspense%20poster%20art%2C%20warm%20amber%20tones%2C%20no%20text&width=400&height=600&seq=bajie-p14&orientation=portrait",
    year: "2024",
    region: "美国",
    genre: "悬疑",
    rating: "8.6",
    episodes: "第 1 季 / 10 集",
    desc: "平静的郊区小镇隐藏着一桩失踪案，新搬来的邻居似乎知道所有人不愿提起的往事。",
  },
  {
    id: "t6",
    title: "边界之外",
    tab: "美剧",
    poster:
      "https://readdy.ai/api/search-image?query=futuristic%20desert%20research%20station%20under%20a%20giant%20warm%20sun%2C%20sci%20fi%20isolation%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p15&orientation=portrait",
    year: "2024",
    region: "美国",
    genre: "科幻",
    rating: "8.4",
    episodes: "第 2 季 / 8 集",
    desc: "边境研究站收到一段来自未来的信号，科考队员们必须在真相与生存之间做出选择。",
  },
  {
    id: "t7",
    title: "权力棋局",
    tab: "美剧",
    poster:
      "https://readdy.ai/api/search-image?query=dimly%20lit%20boardroom%20with%20an%20empty%20leather%20chair%20and%20warm%20desk%20lamp%2C%20tense%20political%20drama%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p16&orientation=portrait",
    year: "2023",
    region: "美国",
    genre: "政治",
    rating: "8.8",
    episodes: "第 1 季 / 12 集",
    desc: "一场看似普通的选举，把幕后的家族、资本与媒体拉上同一张牌桌，没有人是真正的赢家。",
  },
  {
    id: "t8",
    title: "荒野求生者",
    tab: "美剧",
    poster:
      "https://readdy.ai/api/search-image?query=rugged%20mountain%20forest%20campsite%20with%20a%20small%20campfire%20at%20dusk%2C%20survival%20adventure%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p17&orientation=portrait",
    year: "2024",
    region: "美国",
    genre: "冒险",
    rating: "8.1",
    episodes: "第 3 季 / 10 集",
    desc: "十二位普通人被投放在无人荒野，没有补给，没有脚本，只有活下去的本能与彼此的信任。",
  },
  {
    id: "t9",
    title: "都市之恋",
    tab: "韩剧",
    poster:
      "https://readdy.ai/api/search-image?query=seoul%20city%20rooftop%20with%20warm%20fairy%20lights%20at%20night%2C%20romantic%20korean%20drama%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p18&orientation=portrait",
    year: "2024",
    region: "韩国",
    genre: "爱情",
    rating: "8.5",
    episodes: "全 16 集",
    desc: "一位挑剔的建筑师与一位随性的插画师合租同一间公寓，从针锋相对到深夜谈心。",
  },
  {
    id: "t10",
    title: "豪门之影",
    tab: "韩剧",
    poster:
      "https://readdy.ai/api/search-image?query=luxurious%20korean%20mansion%20interior%20with%20warm%20chandelier%20light%2C%20opulent%20dramatic%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p19&orientation=portrait",
    year: "2023",
    region: "韩国",
    genre: "剧情",
    rating: "8.7",
    episodes: "全 20 集",
    desc: "集团继承权之争背后，是被牺牲的亲情与被隐瞒的身世，华服之下暗流汹涌。",
  },
  {
    id: "t11",
    title: "港湾迷雾",
    tab: "韩剧",
    poster:
      "https://readdy.ai/api/search-image?query=rainy%20harbor%20with%20cargo%20containers%20and%20warm%20dock%20lights%2C%20tense%20thriller%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p20&orientation=portrait",
    year: "2024",
    region: "韩国",
    genre: "犯罪",
    rating: "8.3",
    episodes: "全 12 集",
    desc: "港口城市的一桩走私案牵出警队内部的蛀虫，孤身追查的刑警发现自己才是被布下的棋子。",
  },
  {
    id: "t12",
    title: "春日来信",
    tab: "韩剧",
    poster:
      "https://readdy.ai/api/search-image?query=korean%20countryside%20blossom%20road%20with%20a%20bicycle%2C%20soft%20warm%20spring%20light%2C%20healing%20romance%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p21&orientation=portrait",
    year: "2023",
    region: "韩国",
    genre: "治愈",
    rating: "8.6",
    episodes: "全 16 集",
    desc: "辞去大厂工作的女孩回到故乡小镇，在一间旧书店里重遇了少年时代的笔友。",
  },
];

export const ethicalFilms: MovieItem[] = [
  {
    id: "e1",
    title: "母亲的抉择",
    poster:
      "https://readdy.ai/api/search-image?query=a%20middle%20aged%20woman%20silhouette%20by%20a%20window%20at%20dusk%2C%20warm%20muted%20tones%2C%20emotional%20family%20drama%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p22&orientation=portrait",
    year: "2023",
    region: "中国大陆",
    genre: "家庭伦理",
    rating: "8.5",
    desc: "当家庭与自我发生冲突，一位母亲用沉默承担起所有误解，直到多年后孩子们才读懂她的选择。",
  },
  {
    id: "e2",
    title: "沉默的河流",
    poster:
      "https://readdy.ai/api/search-image?query=a%20quiet%20river%20village%20at%20sunset%20with%20a%20lone%20wooden%20boat%2C%20melancholic%20reflective%20mood%2C%20warm%20light%2C%20drama%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p23&orientation=portrait",
    year: "2022",
    region: "中国大陆",
    genre: "文艺",
    rating: "8.7",
    desc: "返乡的女儿重新面对小镇的流言与家族的旧账，在熟悉的河岸边，她学会与过去和解。",
  },
  {
    id: "e3",
    title: "两个女人的夏天",
    poster:
      "https://readdy.ai/api/search-image?query=two%20women%20sitting%20on%20a%20beach%20at%20golden%20hour%2C%20warm%20nostalgic%20emotional%20mood%2C%20painterly%20drama%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p24&orientation=portrait",
    year: "2023",
    region: "中国台湾",
    genre: "剧情",
    rating: "8.4",
    desc: "婆婆与儿媳在一个夏天里被迫同住，从针锋相对到彼此理解，两代女性的心事在潮汐间缓缓打开。",
  },
  {
    id: "e4",
    title: "失落的房间",
    poster:
      "https://readdy.ai/api/search-image?query=an%20old%20apartment%20room%20with%20sunlight%20through%20curtains%20and%20scattered%20letters%2C%20intimate%20emotional%20mood%2C%20drama%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p25&orientation=portrait",
    year: "2022",
    region: "日本",
    genre: "文艺",
    rating: "8.9",
    desc: "整理母亲遗物时，主人公在旧居发现一叠从未寄出的信，一段被时代尘封的往事随之浮现。",
  },
  {
    id: "e5",
    title: "归途列车",
    poster:
      "https://readdy.ai/api/search-image?query=an%20elderly%20man%20on%20a%20slow%20train%20looking%20out%20the%20window%20at%20golden%20fields%2C%20nostalgic%20emotional%20mood%2C%20drama%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p26&orientation=portrait",
    year: "2021",
    region: "中国大陆",
    genre: "剧情",
    rating: "8.6",
    desc: "退休教师踏上最后一趟返乡的绿皮火车，沿途的旅客让他重新梳理了一生的遗憾与牵挂。",
  },
  {
    id: "e6",
    title: "婚约之外",
    poster:
      "https://readdy.ai/api/search-image?query=a%20couple%20standing%20apart%20in%20a%20dim%20warm%20lit%20hallway%2C%20tension%20and%20emotion%2C%20cinematic%20drama%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p27&orientation=portrait",
    year: "2023",
    region: "韩国",
    genre: "剧情",
    rating: "8.2",
    desc: "一场取消的婚礼之后，两个家庭必须面对隐瞒多年的秘密，以及被牺牲掉的彼此的人生。",
  },
];

export const editorPicks = [
  {
    id: "p1",
    title: "长夜将尽",
    poster:
      "https://readdy.ai/api/search-image?query=lonely%20rural%20train%20station%20at%20dawn%20with%20a%20single%20traveler%20and%20warm%20sunrise%20light%2C%20nostalgic%20melancholy%20drama%20film%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p03&orientation=portrait",
    comment: "克制却后劲十足，把父子之间说不出口的话都放进了沉默里。",
    tag: "年度口碑",
    rating: "8.8",
  },
  {
    id: "p2",
    title: "长安谜案",
    poster:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20palace%20corridor%20with%20paper%20lanterns%20and%20a%20figure%20in%20hanfu%2C%20warm%20mysterious%20period%20mystery%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p13&orientation=portrait",
    comment: "服化道考究，案件环环相扣，古装悬疑爱好者不容错过。",
    tag: "国剧精选",
    rating: "8.9",
  },
  {
    id: "p3",
    title: "失落的房间",
    poster:
      "https://readdy.ai/api/search-image?query=an%20old%20apartment%20room%20with%20sunlight%20through%20curtains%20and%20scattered%20letters%2C%20intimate%20emotional%20mood%2C%20drama%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p25&orientation=portrait",
    comment: "节奏很慢，但每一帧都值得细看，适合安静的时候一个人品味。",
    tag: "文艺片单",
    rating: "8.9",
  },
  {
    id: "p4",
    title: "雾都迷踪",
    poster:
      "https://readdy.ai/api/search-image?query=rain%20soaked%20cobblestone%20alley%20at%20dusk%20with%20a%20solitary%20figure%20in%20a%20long%20coat%2C%20warm%20amber%20streetlight%20glow%2C%20moody%20crime%20noir%20film%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p01&orientation=portrait",
    comment: "氛围营造一流，反转落在人物动机上，看完还想倒回去再看一遍开头。",
    tag: "悬疑必看",
    rating: "8.6",
  },
  {
    id: "p5",
    title: "味觉记忆",
    poster:
      "https://readdy.ai/api/search-image?query=rustic%20kitchen%20with%20steaming%20dishes%20and%20warm%20hanging%20lanterns%2C%20cozy%20appetizing%20mood%2C%20soft%20golden%20light%2C%20food%20drama%20film%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p07&orientation=portrait",
    comment: "热腾腾的烟火气，一集一个故事，下饭又下泪。",
    tag: "暖心推荐",
    rating: "8.4",
  },
];

export const rankings = [
  { rank: 1, title: "家国长卷", poster: "https://readdy.ai/api/search-image?query=grand%20traditional%20chinese%20courtyard%20mansion%20in%20autumn%20with%20red%20lanterns%2C%20warm%20nostalgic%20period%20drama%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p10&orientation=portrait", rating: "9.0", heat: "9821", genre: "年代剧" },
  { rank: 2, title: "长安谜案", poster: "https://readdy.ai/api/search-image?query=ancient%20chinese%20palace%20corridor%20with%20paper%20lanterns%20and%20a%20figure%20in%20hanfu%2C%20warm%20mysterious%20period%20mystery%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p13&orientation=portrait", rating: "8.9", heat: "9104", genre: "古装悬疑" },
  { rank: 3, title: "长夜将尽", poster: "https://readdy.ai/api/search-image?query=lonely%20rural%20train%20station%20at%20dawn%20with%20a%20single%20traveler%20and%20warm%20sunrise%20light%2C%20nostalgic%20melancholy%20drama%20film%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p03&orientation=portrait", rating: "8.8", heat: "8760", genre: "文艺剧情" },
  { rank: 4, title: "权力棋局", poster: "https://readdy.ai/api/search-image?query=dimly%20lit%20boardroom%20with%20an%20empty%20leather%20chair%20and%20warm%20desk%20lamp%2C%20tense%20political%20drama%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p16&orientation=portrait", rating: "8.8", heat: "8432", genre: "政治剧" },
  { rank: 5, title: "失落的房间", poster: "https://readdy.ai/api/search-image?query=an%20old%20apartment%20room%20with%20sunlight%20through%20curtains%20and%20scattered%20letters%2C%20intimate%20emotional%20mood%2C%20drama%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p25&orientation=portrait", rating: "8.9", heat: "8207", genre: "文艺" },
  { rank: 6, title: "烟火人间", poster: "https://readdy.ai/api/search-image?query=cozy%20chinese%20family%20dinner%20table%20with%20steaming%20dishes%20and%20warm%20lamps%2C%20heartwarming%20realistic%20family%20drama%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p12&orientation=portrait", rating: "8.7", heat: "7980", genre: "家庭剧" },
  { rank: 7, title: "沉默的河流", poster: "https://readdy.ai/api/search-image?query=a%20quiet%20river%20village%20at%20sunset%20with%20a%20lone%20wooden%20boat%2C%20melancholic%20reflective%20mood%2C%20warm%20light%2C%20drama%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p23&orientation=portrait", rating: "8.7", heat: "7712", genre: "文艺" },
  { rank: 8, title: "港湾迷雾", poster: "https://readdy.ai/api/search-image?query=rainy%20harbor%20with%20cargo%20containers%20and%20warm%20dock%20lights%2C%20tense%20thriller%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p20&orientation=portrait", rating: "8.3", heat: "7455", genre: "犯罪" },
  { rank: 9, title: "味觉记忆", poster: "https://readdy.ai/api/search-image?query=rustic%20kitchen%20with%20steaming%20dishes%20and%20warm%20hanging%20lanterns%2C%20cozy%20appetizing%20mood%2C%20soft%20golden%20light%2C%20food%20drama%20film%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p07&orientation=portrait", rating: "8.4", heat: "7203", genre: "美食" },
  { rank: 10, title: "山海拾光", poster: "https://readdy.ai/api/search-image?query=epic%20fantasy%20landscape%20with%20floating%20mountains%20and%20a%20glowing%20ancient%20tree%2C%20warm%20golden%20light%2C%20adventurous%20painterly%20film%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p02&orientation=portrait", rating: "8.1", heat: "6981", genre: "奇幻" },
];

export const stats = [
  { value: "12,800+", label: "收录影片", desc: "覆盖院线新片与经典老片" },
  { value: "4,300+", label: "电视剧集", desc: "国产剧、美剧、韩剧一站直达" },
  { value: "200+", label: "每日更新", desc: "跟随院线与平台同步上线" },
  { value: "98%", label: "中文字幕", desc: "外语片普遍配备精校字幕" },
];

export const subtitleFeatures = [
  {
    icon: "ri-film-line",
    title: "高清资源专区",
    desc: "按画质与片源整理入口，支持从最新院线到经典修复片的清晰度筛选，观影画质一目了然。",
  },
  {
    icon: "ri-translate-2",
    title: "中文字幕覆盖",
    desc: "外语剧集与影片普遍提供简体中文字幕，常见语种还附带双语对照版本，方便学习与观影。",
  },
  {
    icon: "ri-calendar-check-line",
    title: "每日更新提醒",
    desc: "新片与新剧按上线时间排序，追更的剧集集中在同一入口，不错过任何一集的更新节点。",
  },
  {
    icon: "ri-device-line",
    title: "多端顺畅浏览",
    desc: "手机、平板与桌面均可流畅浏览片单，密集列表在移动端同样保持清晰可读的排版。",
  },
];

export const genreTags = [
  "动作", "喜剧", "爱情", "悬疑", "科幻", "恐怖", "剧情", "犯罪",
  "家庭", "历史", "奇幻", "冒险", "青春", "文艺", "伦理", "古装", "运动", "美食",
];

export const faqs = [
  {
    q: "八戒影院主要提供哪些类型的内容？",
    a: "本站围绕最新电影、电视剧大全以及好看的片推荐三大方向组织片单，同时设有伦理片、中文字幕与高清资源专区，方便按需检索。所有片单均在本页集中呈现，按分类即可快速定位。",
  },
  {
    q: "页面上的影片和剧集信息是怎样排列的？",
    a: "最新电影按上线时间与热度综合排序；电视剧按照产地分为国产剧、美剧、韩剧等标签，可切换查看；排行榜则按热度整理出前 10 名，便于快速挑选。",
  },
  {
    q: "中文字幕覆盖到什么程度？",
    a: "外语影片与剧集普遍配有简体中文字幕，常见语种提供双语对照版本。字幕信息会随条目说明呈现，具体以片源更新为准。",
  },
  {
    q: "伦理片专区包含哪些题材？",
    a: "该专区侧重家庭、情感与社会关系题材的剧情作品，例如《母亲的抉择》《沉默的河流》等，强调人物与情感刻画，适合偏好现实题材的观众。",
  },
  {
    q: "片单多久更新一次？",
    a: "热门影片与剧集通常随院线和平台的上线节奏同步，每日平均更新 200 条左右条目。追更剧集的最新集数会集中展示在电视剧分区。",
  },
  {
    q: "如何在页面里快速找到想看的内容？",
    a: "可以使用顶部导航跳转到对应分区，或在最新电影区按片名搜索、按题材标签筛选。所有筛选都作用在页面已有内容上，即时给出结果反馈。",
  },
];

export const navLinks = [
  { label: "最新电影", href: "#latest" },
  { label: "电视剧大全", href: "#tv" },
  { label: "好看的片", href: "#picks" },
  { label: "伦理片", href: "#ethical" },
  { label: "排行榜", href: "#ranking" },
  { label: "常见问题", href: "#faq" },
];